import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Drawer,
  Popconfirm,
  notification,
} from "antd";
import {
  OrderedListOutlined,
  PlusOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
  MenuUnfoldOutlined,
  AppstoreAddOutlined,
} from "@ant-design/icons";
import EmployeeTableFilter from "../Filters/EmployeeTableFilter";
import { ColumnHelper } from "../../util/TableHelper";
import { Link, useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import EmployeeAddForm from "../Forms/EmployeeAddForm";
import EmployeeUpdateForm from "../Forms/EmployeeUpdateForm";
import EmployeeMonthlyPlanAdd from "../Forms/EmployeeMonthlyPlanAdd";
import EmployeeManualTransactionAdd from "../Forms/EmployeeManualTransactionAdd";

const EmployeeList = (props) => {
  const [options, setOptions] = useState({ pageTitle: "PERSONEL LİSTESİ" });
  const [employees, setEmployees] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [dataState, setDataState] = useState([{ skip: 0, take: 20 }]);
  const [addFormVisibility, setAddFormVisibility] = useState(false);
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const [monthlyPlanAddVisibility, setMonthlyPlanAddVisibility] =
    useState(false);
  const [manualTransactionAddVisibility, setManualTransactionAddVisibility] =
    useState(false);

  const history = useHistory();

  useEffect(() => {
    setFilterValues();
    getTableData();
  }, [tableDataQueryOptions]);

  const getTableData = () => {
    setEmployees({
      ...employees,
      loading: true,
    });

    const { skip, take, filter } = tableDataQueryOptions;
    const order = "&$orderby=addDate desc";
    let query = "";
    const conditions = ["Name ne 'Diğer'"];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }
    RequestHandler.get(
      `/Employee?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setEmployees({
        data: response.value,
        loading: false,
        total: response["@odata.count"],
      });
    });
  };

  const renderDecimal = (value) =>
    value !== null ? ColumnHelper.renderDecimal(value) : null;

  const onAddEmployeeSuccess = () => {
    getTableData();
    setAddFormVisibility(false);
  };

  const handleOnClickUpdate = (record) => {
    RequestHandler.get(`/Employee/GetById/${record.id}`).then((response) => {
      if (response) {
        setUpdateFormData(response);
        setUpdateFormVisibility(true);
      }
    });
  };

  const onUpdateEmployeeSuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
  };

  const onMonthlyPlanAddSuccess = () => {
    getTableData();
    setMonthlyPlanAddVisibility(false);
  };

  const onManualTransactionAddSuccess = () => {
    getTableData();
    setManualTransactionAddVisibility(false);
  };

  const setFilterValues = () => {
    const filterValues = {
      ...tableDataQueryOptions.values,
      skip: tableDataQueryOptions.skip,
      take: tableDataQueryOptions.take,
      current: tableDataQueryOptions.current,
      order: tableDataQueryOptions.order,
      filter: tableDataQueryOptions.filter,
    };
    const queryString = queryHelper.getQueryFromValues(filterValues);

    history.replace({
      pathname: window.location.pathname,
      search: queryString,
    });
  };

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "Uyarı",
      description: "Pasif olan personeller güncellenemez.",
    });
  };

  const columns = [
    {
      title: "Personel Adı",
      dataIndex: "name",
      key: "name",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return text.substring(0, 25).length < 25
          ? text.substring(0, 25) + ""
          : text.substring(0, 25) + "...";
      },
    },
    {
      title: "E-Mail",
      dataIndex: "email",
      key: "email",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return text.substring(0, 30).length < 30
          ? text.substring(0, 30) + ""
          : text.substring(0, 30) + "...";
      },
    },
    {
      title: "T.C. Kimlik Numarası",
      dataIndex: "tcNo",
      key: "tcNo",
      align: "left",
    },
    {
      title: "Iban",
      dataIndex: "iban",
      key: "iban",
      align: "left",
    },
    {
      title: "Maaş Plan Girişi",
      dataIndex: "id",
      align: "center",
      render: (text, record) => (
        <Button
          onClick={() => {
            if (record.isActive) {
              setUpdateFormData(record);
              setMonthlyPlanAddVisibility(true);
            } else {
              openNotificationWithIcon("warning");
            }
          }}
          icon={<AppstoreAddOutlined />}
          type="link"
          style={{ fontSize: "120%", color: "#9254de", paddingTop: 7 }}
        ></Button>
      ),
    },
    {
      title: "Personel Ödeme Girişi",
      dataIndex: "id",
      align: "center",
      render: (text, record) => (
        <Button
          onClick={() => {
            if (record.isActive) {
              setUpdateFormData(record);
              setManualTransactionAddVisibility(true);
            } else {
              openNotificationWithIcon("warning");
            }
          }}
          icon={<AppstoreAddOutlined />}
          type="link"
          style={{ fontSize: "120%", color: "#a0d911", paddingTop: 7 }}
        ></Button>
      ),
    },
    {
      title: "Personel Maaş Hareketleri",
      dataIndex: "",
      align: "center",
      render: (record) =>
        record.isActive ? (
          <Link
            style={{ fontSize: "120%", color: "gray" }}
            to={`/employee-transaction-list/${record.id}`}
          >
            <OrderedListOutlined />
          </Link>
        ) : (
          <Button
            onClick={() => {
              openNotificationWithIcon("warning");
            }}
            icon={<OrderedListOutlined />}
            type="link"
            style={{ fontSize: "120%", color: "gray", paddingTop: 7 }}
          ></Button>
        ),
    },
    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        employees.total >= 1 ? (
          row.isActive ? (
            <a onClick={() => handleOnClickUpdate(row)}>
              <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
            </a>
          ) : (
            <a
              onClick={() => {
                openNotificationWithIcon("warning");
              }}
              style={{
                color: "orange",
                fontSize: "130%",
                paddingBottom: "20px",
              }}
            >
              <EditOutlined />
            </a>
          )
        ) : null,
    },
    {
      title: "Durum",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        row.isActive ? (
          <Popconfirm
            title="Pasif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(data)}
          >
            <a style={{ color: "green", fontSize: "130%" }}>
              <CheckCircleOutlined />
            </a>
          </Popconfirm>
        ) : (
          <Popconfirm
            title="Aktif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(data)}
          >
            <a style={{ color: "red", fontSize: "130%" }}>
              <CloseCircleOutlined />
            </a>
          </Popconfirm>
        ),
    },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const dataStateChange = (e) => {
    setEmployees(e);
  };

  const handleActivePassive = (id) => {
    RequestHandler.delete(`/employee/${id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Button
            type="primary"
            onClick={() => {
              setAddFormVisibility(true);
            }}
            style={{ marginBottom: 0 }}
          >
            <PlusOutlined /> Personel Ekle
          </Button>
        </Col>
      </Row>

      <EmployeeTableFilter
        data={tableDataQueryOptions.values}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            dataSource={employees.data}
            loading={employees.loading}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: employees.total,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>
      <Drawer
        id="addEmployeeDrawer"
        title="Personel Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddFormVisibility(false)}
        visible={addFormVisibility}
      >
        <EmployeeAddForm onSuccess={onAddEmployeeSuccess} />
      </Drawer>

      <Drawer
        id="updateEmployeeDrawer"
        title="Personel Bilgileri Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={updateFormVisibility}
      >
        <EmployeeUpdateForm
          data={updateFormData}
          onSuccess={onUpdateEmployeeSuccess}
        />
      </Drawer>

      <Drawer
        title="Maaş Plan Ekle"
        width={241}
        onClose={() => setMonthlyPlanAddVisibility(false)}
        visible={monthlyPlanAddVisibility}
        destroyOnClose={true}
        bodyStyle={{ paddingTop: 40 }}
        footer={<div style={{ textAlign: "right" }}></div>}
      >
        <EmployeeMonthlyPlanAdd
          data={updateFormData}
          onSuccess={onMonthlyPlanAddSuccess}
        />
      </Drawer>

      <Drawer
        title="Personel Ödeme Ekle"
        width={241}
        onClose={() => setManualTransactionAddVisibility(false)}
        visible={manualTransactionAddVisibility}
        destroyOnClose={true}
        bodyStyle={{ paddingTop: 40 }}
        footer={<div style={{ textAlign: "right" }}></div>}
      >
        <EmployeeManualTransactionAdd
          data={updateFormData}
          onSuccess={onManualTransactionAddSuccess}
        />
      </Drawer>
    </>
  );
};

export default EmployeeList;
